<template>
  <DialogBase
    title="Gửi thông báo qua Onekids"
    :visible.sync="isVisible"
    dialog-class="sk-dialog--md"
    @close="handleClose"
  >
    <div class="sk-dialog__content">
      <el-form
        ref="formRef"
        :model="formData"
        :rules="formRules"
        label-position="top"
        label-width="auto"
      >
        <div class="sk-panel">
          <div class="sk-panel-head">
            <div class="sk-panel-icon"><i class="el-icon-message" /></div>
            <div>
              <p class="sk-panel-title">Nội dung thông báo</p>
              <p class="sk-panel-subtitle">Tiêu đề và nội dung gửi qua ứng dụng Onekids</p>
            </div>
          </div>
            
          <el-form-item label="Tiêu đề" prop="sendTitle">
            <el-input v-model="formData.sendTitle" placeholder="Nhập tiêu đề thông báo" />
          </el-form-item>

          <el-form-item label="Nội dung" prop="sendContent" class="sk-u-mt-12">
            <el-input type="textarea" :rows="6" v-model="formData.sendContent" placeholder="Nhập nội dung thông báo..." />
          </el-form-item>
        </div>

        <div class="sk-panel sk-u-mt-12">
          <div class="sk-panel-head">
            <div class="sk-panel-icon sk-panel-icon--success"><i class="el-icon-paperclip" /></div>
            <div>
              <p class="sk-panel-title">Đính kèm</p>
              <p class="sk-panel-subtitle">Tùy chọn đính kèm hóa đơn và tệp tin bổ sung</p>
            </div>
          </div>
          
          <el-form-item>
            <div>
              <el-checkbox v-model="formData.statusAttachNotifyFinance">Đính kèm thông tin học phí</el-checkbox>
              <el-checkbox v-model="formData.attachOrderPDF">Đính kèm ảnh hóa đơn học phí</el-checkbox>
            </div>
            
            <div class="sk-note sk-note--warning sk-u-mt-12" v-if="formData.statusAttachNotifyFinance">
              <i class="el-icon-warning-outline" />
              <span>Nội dung của bạn sẽ được đính kèm theo cả thông báo học phí!</span>
            </div>
          </el-form-item>
          
          <el-form-item label="File đính kèm (Tối đa 3 file, mỗi file ≤ 5MB)" class="sk-u-mt-12">
            <el-upload
              action=""
              :auto-upload="false"
              multiple
              :limit="5"
              :file-list="fileList"
              :on-change="toggleUpload"
              :on-remove="handleRemove"
              :before-remove="beforeRemove"
              :on-exceed="handleExceed"
              ref="upload"
            >
              <el-button size="mini" type="primary" plain icon="el-icon-upload2">Tải lên file đính kèm</el-button>
            </el-upload>
          </el-form-item>
        </div>
      </el-form>
    </div>

    <!-- Footer -->
    <template #footer>
      <div class="sk-dialog__footer">
        <el-button class="btn-cancel" plain @click="handleClose">Hủy</el-button>
        <el-button class="btn-save" type="primary" :loading="isSaving" @click="handleSave">
          Gửi thông báo
        </el-button>
      </div>
    </template>
  </DialogBase>
</template>

<script>
import DialogBase from "@/components/DialogBase.vue";
import ManagingStudentInvoiceService from "@/services/tutition_v3/ManagingStudentInvoiceService";
import NotifyMessage from "@/commonFuncion/NotifyMessage";

export default {
  components: { DialogBase },
  data() {
    return {
      isVisible: false,
      isSaving: false,
      fileList: [],
      multipartFileList: [],
      idxList: [],
      formData: {
        sendTitle: "",
        sendContent: "",
        statusAttachNotifyFinance: false,
        attachOrderPDF: false,
      },
      formRules: {
        sendTitle: [
          { required: true, message: "Vui lòng nhập tiêu đề", trigger: "blur" }
        ],
        sendContent: [
          { required: true, message: "Vui lòng nhập nội dung", trigger: "blur" }
        ]
      }
    };
  },
  methods: {
    open(idxList) {
      this.idxList = idxList;
      this.resetForm();
      this.isVisible = true;
    },
    handleClose() {
      this.isVisible = false;
      this.resetForm();
      this.$emit("close");
    },
    resetForm() {
      if (this.$refs.formRef) {
        this.$refs.formRef.resetFields();
      }
      this.formData.statusAttachNotifyFinance = false;
      this.formData.attachOrderPDF = false;
      this.formData.sendTitle = "";
      this.formData.sendContent = "";
      this.fileList = [];
      this.multipartFileList = [];
      if (this.$refs.upload) {
        this.$refs.upload.clearFiles();
      }
    },
    handleRemove(file) {
      let index = this.fileList.findIndex(f => f.uid === file.uid);
      if (index >= 0) {
        this.fileList.splice(index, 1);
        this.multipartFileList.splice(index, 1);
      }
    },
    handleExceed() {
      NotifyMessage.leftCornerNotificationWarning("Bạn chỉ được chọn tối đa 5 file");
    },
    toggleUpload(file, fileList) {
      this.multipartFileList = fileList;
      this.fileList = fileList;
    },
    beforeRemove(file) {
      return this.$confirm(`Bạn chắc chắn muốn xóa ${file.name} ?`, "Xác nhận", {
        type: "warning"
      });
    },
    async handleSave() {
      const valid = await this.$refs.formRef.validate().catch(() => false);
      if (!valid) return;

      let sumSize = 0;
      let isOversize = false;
      
      this.multipartFileList.forEach((element) => {
        sumSize += element.size;
        if (element.size > 5 * 1024 * 1024) {
          isOversize = true;
        }
      });
      
      if (isOversize) {
        NotifyMessage.leftCornerNotificationError("Có file kích thước vượt quá 5MB");
        return;
      }
      if (sumSize > 25 * 1024 * 1024) {
        NotifyMessage.leftCornerNotificationError("Tổng kích thước file vượt quá 25MB");
        return;
      }

      this.isSaving = true;
      let submitData = new FormData();

      submitData.append("statusAttachNotifyFinance", this.formData.statusAttachNotifyFinance);
      submitData.append("sendTitle", this.formData.sendTitle);
      submitData.append("sendContent", this.formData.sendContent);
      submitData.append("attachOrderPDF", this.formData.attachOrderPDF);
      
      this.idxList.forEach((idx) => {
        submitData.append("idxList", idx);
      });

      if (this.multipartFileList.length > 0) {
        this.multipartFileList.forEach((element) => {
          submitData.append("multipartFileList", element.raw);
        });
      }

      try {
        const response = await ManagingStudentInvoiceService.sendAppForInvoices(submitData);
        if (response?.data?.status === 200 || response?.data?.code === "0" || response?.data?.data === true) {
          NotifyMessage.leftCornerNotificationSuccess(response?.data?.message || "Gửi thông báo qua Onekids thành công!");
          this.$emit("saved");
          this.handleClose();
        } else {
          throw new Error(response?.data?.message || "Gửi thông báo thất bại.");
        }
      } catch (error) {
        console.error(error);
        const errorMsg = error?.response?.data?.message || error.message || "Không thể gửi thông báo cho các phiếu thu đã chọn.";
        NotifyMessage.leftCornerNotificationError(errorMsg);
      } finally {
        this.isSaving = false;
      }
    }
  }
};
</script>

<style scoped lang="scss">
@import "@/assets/style/sk-dialog.scss";
</style>
